export default function getWeekOfYearFromTimestamp(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000); // Convert Unix timestamp to milliseconds and create Date object

    // Set the date to the nearest Thursday (ISO week starts on Monday)
    date.setDate(date.getDate() + (4 - (date.getDay() || 7)));

    // Get the first day of the year
    const yearStart = new Date(date.getFullYear(), 0, 1);

    // Calculate the difference in days from the year's start
    const dayOfYear = Math.floor((date - yearStart) / (24 * 60 * 60 * 1000)) + 1;

    // Calculate the week number
    const weekNumber = Math.ceil(dayOfYear / 7);

    return weekNumber;
}